import { FETCH_REPORT_PAP_REQUEST, FETCH_REPORT_PAP_SUCCESS, FETCH_REPORT_PAP_FAILURE } from './actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const reportPAPReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REPORT_PAP_REQUEST:
            return { ...state, loading: true };
        case FETCH_REPORT_PAP_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_REPORT_PAP_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default reportPAPReducer;
